import React from 'react'
import { Slider } from 'antd'

export const CompanySlider = ({sliderHandler}) => {

    const onChange = function(value)
    {
      sliderHandler(value)
    }

    const marks = {
        0: 'All',
        1:'1',
        2:'2',
        3:'3',
        4:'4',
        5:'5'
      };

  return (
    <div style={{display:'flex', alignItems: 'center', }}>
      <h6 style={{textTransform: 'none', fontWeight: 700, fontSize: '12px', marginRight:'10px'}}>Ocena Google</h6>
      <Slider marks={marks} step={1} max={5} min={0} defaultValue={0} style={{ width: '300px' }} onChange={onChange}/>
    </div>
  )
}
